import { Component } from '@angular/core';
import { AnalyticsEvent, AnalyticsService } from '@lsq-frontend/angular-shared/features/analytics';

@Component({
    selector: 'lsq-unsupported-browser-modal',
    template: `
        <p [style.font-size]="'1.5rem'">
            You may experience some issues with functionality if you proceed. We recommend using one
            of the following browsers for the best experience:
        </p>
        <ul [style.margin-top]="'0.5rem'">
            <li>
                <a
                    href="https://www.google.com/chrome/"
                    (click)="triggerChromeAnalytics()"
                    target="_blank"
                    >Google Chrome</a
                >
            </li>
            <li>
                <a
                    href="https://www.mozilla.org/en-US/"
                    (click)="triggerFirefoxAnalytics()"
                    target="_blank"
                    >Firefox</a
                >
            </li>
            <li>Safari (Mac)</li>
        </ul>
    `
})
export class LsqUnsupportedBrowserModalComponent {
    constructor(private analyticsService: AnalyticsService) {}

    public triggerChromeAnalytics(): void {
        this.analyticsService.triggerSimpleEvent(AnalyticsEvent.DownloadGoogleChrome);
    }

    public triggerFirefoxAnalytics(): void {
        this.analyticsService.triggerSimpleEvent(AnalyticsEvent.DownloadFirefox);
    }
}
